import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var PlusIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 13 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: size === 13 ? /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M7.25.75a.75.75 0 0 0-1.5 0v5h-5a.75.75 0 0 0 0 1.5h5v5a.75.75 0 0 0 1.5 0v-5h5a.75.75 0 0 0 0-1.5h-5v-5Z"
        }) : size === 16 ? /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M8.75.75a.75.75 0 0 0-1.5 0v6.5H.75a.75.75 0 0 0 0 1.5h6.5v6.5a.75.75 0 0 0 1.5 0v-6.5h6.5a.75.75 0 0 0 0-1.5h-6.5V.75Z"
        }) : /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M12.75.75a.75.75 0 0 0-1.5 0v10.5H.75a.75.75 0 0 0 0 1.5h10.5v10.5a.75.75 0 0 0 1.5 0v-10.5h10.5a.75.75 0 0 0 0-1.5h-10.5V.75Z"
        })
    }));
};
